<template>
  <div class="meun-box">
    <div class="meun-content">
      <div class="meun-search">
        <el-input
          v-model="storeName"
          class="w-50 m-2"
          placeholder="搜索名称"
          :prefix-icon="Search"
          clearable
          @keyup.enter="query"
        />
        <el-button
          style="margin-left: 8px"
          size="default"
          type="primary"
          @click="query"
        >
          查询
        </el-button>
      </div>
      <div class="meun-list">
        <el-tree
          ref="treeRef"
          node-key="id"
          :data="list"
          :props="props"
          draggable
          :filter-node-method="filterMethod"
          highlight-current
          :allow-drop="allowDrop"
          default-expand-all
          :current-node-key="id"
          :empty-text="emptyText"
          :indent="28"
          @node-click="handleTreeItem"
        >
          <template #default="scope">
            <span
              class="custom-tree-node"
              :class="scope.data.icon ? 'isIcon' : ''"
            >
              <span>{{ scope.node.label }}</span>
              <slot :row="scope" name="more" />
            </span>
          </template>
        </el-tree>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Search } from "@element-plus/icons-vue";
import { ref, onMounted, defineProps } from "vue";
import type { AllowDropType } from "element-plus/es/components/tree/src/tree.type";
import type Node from "element-plus/es/components/tree/src/model/node";

const storeName = ref("");

const emptyText = ref("暂无搜索结果");
const props = {
  value: "id",
  label: "label",
  children: "children",
};

const propsData = defineProps<{
  list: TreeList[];
  id: string | number; // 当前选中节点
}>();

const treeRef = ref();

// 搜索查询
const query = () => {
  treeRef.value?.filter(storeName.value);
};

// 拖拽
const allowDrop = (draggingNode: Node, dropNode: Node, type: AllowDropType) => {
  if (draggingNode.level === dropNode.level) {
    if (draggingNode.parent.id === dropNode.parent.id) {
      // 向上拖拽 || 向下拖拽
      return type === "prev" || type === "next";
    }
  } else {
    // 不同级进行处理
    return false;
  }
};
// 搜索过滤
const filterMethod = (query: string, node: Node) => {
  return node.label?.includes(query);
};

const handleTreeItem = (data: Tree) => {
  console.log(data);
};

onMounted(() => {
  const list = document.querySelectorAll(".isIcon");
  list.forEach((v) => {
    if (!v.parentNode) return;
    v.parentNode.children[0].className += " transparent";
  });
  treeRef.value?.setCurrentKey(propsData.id);
});
</script>
<style scoped lang="scss">
.meun-box {
  width: 380px;
  height: calc(100% - 57px);
  background: #f2f6fb;
  padding: 8px;
  border-radius: 6px 6px 6px 6px;
  .meun-content {
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    .meun-search {
      padding: 14px;
      box-sizing: border-box;
      display: flex;
    }
  }
}

.meun-list {
  height: calc(100% - 70px);

  overflow: auto;
  :deep(.el-tree-node__content) {
    height: 40px;
  }

  :deep(.el-tree > .el-tree-node > .el-tree-node__content) {
    padding-left: 10px !important;
  }

  :deep(.el-tree-node > .el-tree-node__content:hover > .custom-tree-node) {
    .more {
      display: block !important;
    }
  }

  :deep(.el-tree-node__content > .el-tree-node__expand-icon) {
    color: transparent;
  }
  :deep(.el-tree-node__content > .el-tree-node__expand-icon)::before {
    content: url("https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230322/yMcOaotPTn53xIli.png");
    width: 8px;
    height: 11px;
    z-index: -1;
  }
  :deep(.el-tree-node__expand-icon.is-leaf)::before {
    content: url("https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230322/A6vxQvrcLoedfDnm.png");
    z-index: -1;
  }
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  position: relative;
  :deep(.more) {
    display: none;
  }
}

:deep(.transparent) {
  opacity: 0 !important;
}
</style>
